import { defineMessages } from 'react-intl';

export const messages: {
	noClassification: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	classifyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	selectClassification: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	updateButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	changeLevel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rules: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dataClassificationLevel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dataClassificationLevelDialog: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	classificationLevelGuidelines: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceAutoClassification: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceUserClassification: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceSpaceDefaultClassification: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceOrgDefaultClassification: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceNoneClassification: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceAutoClassificationUserOverrideDisallow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceUserClassificationUserOverrideDisallow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceSpaceDefaultClassificationUserOverrideDisallow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceOrgDefaultClassificationUserOverrideDisallow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceNoneClassificationUserOverrideDisallow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceAutoClassificationNotContainerAdmin: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceUserClassificationNotContainerAdmin: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceSpaceDefaultClassificationNotContainerAdmin: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceOrgDefaultClassificationNotContainerAdmin: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceNoneClassificationNotContainerAdmin: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assignClassificationLevel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	lowestPermittedLevelOrgDefault: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	lowestPermittedLevelSpaceDefault: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	lowestPermittedLevelAutoClassification: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noSelection: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noSelectionDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assignButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noClassification: {
		id: 'data-classification-level.no-classification',
		defaultMessage: 'No classification',
		description: 'Text for the no classification option',
	},
	classifyContent: {
		id: 'data-classification-level.edit-popup.classify-content',
		defaultMessage: 'Classify content',
		description: 'Text for the header of the edit popup',
	},
	selectClassification: {
		id: 'data-classification-level.edit-popup.select-classification',
		defaultMessage: 'Select classification',
		description: 'Text for the label of the select dropdown to select a classification',
	},
	updateButton: {
		id: 'data-classification-level.edit-popup.update-button',
		defaultMessage: 'Update',
		description:
			'Label for the update button in the data classification edit popup. This button is used to save changes to the selected classification level.',
	},
	cancelButton: {
		id: 'data-classification-level.edit-popup.cancel-button',
		defaultMessage: 'Cancel',
		description:
			'Label for the cancel button in the data classification edit popup. This button is used to close the popup without saving any changes to the classification level.',
	},
	changeLevel: {
		id: 'data-classification-level.read-popup.change-level',
		defaultMessage: 'Change level',
		description: 'Text for the button that changes the level of the selected classification',
	},
	rules: {
		id: 'data-classification-level.rules',
		defaultMessage: '({associatedPoliciesCount, plural, one {# rule} other {# rules}})',
		description:
			'Text next to the title of the classification describing the number of rules associated',
	},
	dataClassificationLevel: {
		id: 'data-classification-level.data-classification-level',
		defaultMessage: 'Data classification level',
		description: 'Aria label for data classification level',
	},
	dataClassificationLevelDialog: {
		id: 'data-classification-level.read-popup.data-classification-level',
		defaultMessage: 'Data classification level Dialog',
		description: 'Aria label for data classification level read popup dialog',
	},
	classificationLevelGuidelines: {
		id: 'data-classification-level.read-popup.heading',
		defaultMessage: 'Classification level guidelines',
		description: 'Heading for the classification level read popup',
	},
	sourceAutoClassification: {
		id: 'data-classification-level.read-popup.source-auto-classification',
		defaultMessage:
			'The current classification level is based on information detected in the content. <a>Update classification level</a>',
		description: 'Text for the auto classification source',
	},
	sourceUserClassification: {
		id: 'data-classification-level.read-popup.source-user-classification',
		defaultMessage:
			'A user assigned the current classification level. <a>Update classification level</a>',
		description: 'Text for the user classification source',
	},
	sourceSpaceDefaultClassification: {
		id: 'data-classification-level.read-popup.source-space-default-classification',
		defaultMessage:
			'The current classification level is the default for this space. <a>Update classification level</a>',
		description: 'Text for the space default classification source',
	},
	sourceOrgDefaultClassification: {
		id: 'data-classification-level.read-popup.source-org-default-classification',
		defaultMessage:
			'The current classification level is the default for your organization. <a>Update classification level</a>',
		description: 'Text for the org default classification source',
	},
	sourceNoneClassification: {
		id: 'data-classification-level.read-popup.source-none-classification',
		defaultMessage: '<a>Update classification level</a>',
		description: 'Text for none classification source',
	},
	sourceAutoClassificationUserOverrideDisallow: {
		id: 'data-classification-level.read-popup.source-auto-classification-user-override-disallow',
		defaultMessage:
			"The current classification level is based on information detected in the content. Updates to classification levels aren't permitted.",
		description: 'Text for the auto classification source when user override is disallowed',
	},
	sourceUserClassificationUserOverrideDisallow: {
		id: 'data-classification-level.read-popup.source-user-classification-user-override-disallow',
		defaultMessage:
			"A user assigned the current classification level. Updates to classification levels aren't permitted.",
		description: 'Text for the user classification source when user override is disallowed',
	},
	sourceSpaceDefaultClassificationUserOverrideDisallow: {
		id: 'data-classification-level.read-popup.source-space-default-classification-user-override-disallow',
		defaultMessage:
			"The current classification level is the default for this space. Updates to classification levels aren't permitted.",
		description:
			'Text for the space default classification source when user override is disallowed',
	},
	sourceOrgDefaultClassificationUserOverrideDisallow: {
		id: 'data-classification-level.read-popup.source-org-default-classification-user-override-disallow',
		defaultMessage:
			"The current classification level is the default for your organization. Updates to classification levels aren't permitted.",
		description: 'Text for the org default classification source when user override is disallowed',
	},
	sourceNoneClassificationUserOverrideDisallow: {
		id: 'data-classification-level.read-popup.source-none-classification-user-override-disallow',
		defaultMessage: "Updates to classification levels aren't permitted.",
		description: 'Text for none classification source when user override is disallowed',
	},
	sourceAutoClassificationNotContainerAdmin: {
		id: 'data-classification-level.read-popup.source-auto-classification-not-container-admin',
		defaultMessage:
			'The current classification level is based on information detected in the content. Only users who can manage space settings can update the current classification level.',
		description:
			'Text for the auto classification source when user is not a space admin and only space admins can update classification levels',
	},
	sourceUserClassificationNotContainerAdmin: {
		id: 'data-classification-level.read-popup.source-user-classification-not-container-admin',
		defaultMessage:
			'A user assigned the current classification level. Only users who can manage space settings can update the current classification level.',
		description:
			'Text for the user classification source when user is not a space admin and only space admins can update classification levels',
	},
	sourceSpaceDefaultClassificationNotContainerAdmin: {
		id: 'data-classification-level.read-popup.source-space-default-classification-not-container-admin',
		defaultMessage:
			'The current classification level is the default for this space. Only users who can manage space settings can update the current classification level.',
		description:
			'Text for the space default classification source when user is not a space admin and only space admins can update classification levels',
	},
	sourceOrgDefaultClassificationNotContainerAdmin: {
		id: 'data-classification-level.read-popup.source-org-default-classification-not-container-admin',
		defaultMessage:
			'The current classification level is the default for your organization. Only users who can manage space settings can update the current classification level.',
		description:
			'Text for the org default classification source when user is not a space admin and only space admins can update classification levels',
	},
	sourceNoneClassificationNotContainerAdmin: {
		id: 'data-classification-level.read-popup.source-none-classification-not-container-admin',
		defaultMessage:
			'Only users who can manage space settings can update the current classification level.',
		description:
			'Text for none classification source when user is not a space admin and only space admins can update classification levels',
	},
	assignClassificationLevel: {
		id: 'data-classification-level.edit-popup.assign-classification-level',
		defaultMessage: 'Assign classification level',
		description: 'Text for the header of the assign classification level popup',
	},
	lowestPermittedLevelOrgDefault: {
		id: 'data-classification-level.edit-popup.lowest-permitted-level-org-default',
		defaultMessage:
			"Classification levels less sensitive than the organization default aren't available.",
		description:
			'Text for the lowest permitted level in your organization when the lowest permitted level is the organization default',
	},
	lowestPermittedLevelSpaceDefault: {
		id: 'data-classification-level.edit-popup.lowest-permitted-level-space-default',
		defaultMessage: "Classification levels less sensitive than the space default aren't available.",
		description:
			'Text for the lowest permitted level in this space when the lowest permitted level is the space default',
	},
	lowestPermittedLevelAutoClassification: {
		id: 'data-classification-level.edit-popup.lowest-permitted-level-auto-classification',
		defaultMessage:
			"Classification levels less sensitive than the level automatically applied aren't available.",
		description:
			'Text for the lowest permitted level in this space when the lowest permitted level is the auto classification',
	},
	noSelection: {
		id: 'data-classification-level.edit-popup.no-selection',
		defaultMessage: 'No selection',
		description: 'Text for the no selection option',
	},
	noSelectionDescription: {
		id: 'data-classification-level.edit-popup.no-selection-description',
		defaultMessage:
			'The classification level will be updated based on the default or detected content.',
		description: 'Description for the no classification override option',
	},
	assignButton: {
		id: 'data-classification-level.edit-popup.assign-button',
		defaultMessage: 'Assign',
		description: 'Text for the assign button that assigns a classification level to the content',
	},
});
